<div class="objectives-popover p-3">
	<p class="text-sm font-bold text-default_text mb-3 px-1">Selecciona un proceso</p>

	<div *ngIf="loading" class="flex justify-center py-6">
		<ion-spinner name="crescent" class="text-primary"></ion-spinner>
	</div>

	<div *ngIf="!loading && processes.length === 0" class="text-xs text-light_text text-center py-6">
		No tienes procesos disponibles.
	</div>

	<div class="flex flex-col gap-3">
		<app-proceso-desempenio-card
			*ngFor="let process of processes"
			[process]="process"
			(cardClick)="select(process)"
		></app-proceso-desempenio-card>
	</div>
</div>
